import { removeFirstAndLastSlashes } from '../../../utils/form/validation/allowed-characters';

export const getRegexPattern = (pattern: string, flag?: string) =>
  new RegExp(removeFirstAndLastSlashes(pattern), flag);

export const inputIsMatching = (pattern: string, inputValue: string) =>
  getRegexPattern(pattern).test(inputValue);
